<template>
  <div class="mini-room-box">
    <!-- 未实名 -->
    <div v-if="!IMInfo.idCard" class="no-idCard">患者暂未实名认证，请提醒患者至个人中心进行实名认证</div>
    <div v-else> 
      <div class="Box"> 
        <el-scrollbar style="height: 100%" v-show="!isEdit">
          <div>
            <!-- 剩余权益 -->
            <div v-if="totalRightsCount && $store.state.serviceItem.status != 1 && $store.state.serviceItem.status == 5"
              class="rest-rights">
              <div class="justify-align-style rest-line-one">
                <div class="rest-left">剩余权益：</div>
                <div class="rest-right">
                  <span @click="handleUseRights">使用权益</span>
                  <span class="new-interrogation" style="margin-left:16px" @click="addNewDialogue">新增问诊</span>
                </div>
              </div>
              <ul>
                <li v-for="item in rightsData" :key="item.id">
                  {{item.name}}
                  <span class="rights-blue" v-if="item.ruleType != 1">{{item.count}}</span>
                  <span :class="item.ruleType == 1 ? 'rights-blue' : ''">{{item.ruleType == 1 ? '不限制' : '次'}}</span>
                </li>
              </ul>
              <div v-if="rightsData.length == 0" class="no-rights">暂无权益</div>
            </div>
            <div class="add-interrogation" v-else>
              <span style="margin-left:16px" @click="addNewDialogue">新增问诊</span>
            </div> 
          </div>
          <div v-if="doingList && doingList.length"> 
            <h3>正在进行问诊</h3>
            <div class="rest-rights doing-inquiry" v-for="item in doingList" :key="item.id">
              <div class="justify-align-style inquiry-style" v-if="item.mode === 1">
                <div><span>服务医生：</span>{{item.doctorName}}（{{item.hospitalNameOfDoctor}}）</div>
                <div class="pay-status">{{item.inquiryStatusName}}</div>
              </div>
              <div class="justify-align-style inquiry-style" v-if="item.mode === 2">
                <div><span>服务医生：</span>{{item.doctorTeamName}}（{{item.hospitalNameOfDoctorTeam}}）</div>
                <div class="pay-status">{{item.inquiryStatusName}}</div>
              </div>
              <div class="justify-align-style inquiry-style">
                <div><span>问诊类型：</span>{{item.serviceName}}</div>
                <div><span>服务时长：</span>{{item.serviceTime}}{{item.timeUnit == 1 ? '分钟':'小时'}}</div>
              </div>
              <div class="justify-align-style inquiry-style">
                <div><span>开启时间：</span>{{item.startTime}}</div>
                <div v-if="item.mode == 3">
                  <div class="free-clinic">
                    <img src="@/assets/images/free.png">义诊
                  </div>
                  <span class="money-num">¥ {{item.servicePrice / 100}}</span>元
                </div>
                <div v-if="item.payMode == 1">在线问诊权益抵扣</div>
              </div>
              <div style="margin-bottom:16px" class="inquiry-style">
                <span>{{item.inquiryTheme}}</span>
              </div>
              <div class="justify-align-style inquiry-style order-num-line">
                <div><span>订单编号：</span>{{item.orderNo}}</div>
                <div>
                  <el-button v-if="item.inquiryStatus == 1" size="small" class="cancel-order"
                    @click="handleCaseMgrCancelled(item)">取消订单</el-button>
                  <el-button v-if="item.inquiryStatus == 2 || item.inquiryStatus == 3" type="primary" size="small"
                    @click="startDialog(item,false)">进入对话</el-button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="doneList || doingList">
            <h3>历史问诊</h3>
            <div class="rest-rights doing-inquiry" v-for="item in doneList" :key="item.id">
              <div class="justify-align-style inquiry-style">
                <div class="justify-team-info">
                  <span v-if="item.mode === 1">{{item.doctorName}}</span>
                  <span v-if="item.mode === 2">{{item.doctorTeamName}}</span>
                  <span>{{item.serviceName}}</span><span><span class="money-num">¥
                      {{item.servicePrice / 100}}</span>元</span>
                  <span>{{item.serviceTime}}{{item.timeUnit == 1 ? '分钟':'小时'}}</span>
                </div>
                <div><span style="margin-right:16px">{{item.startTime}}</span>{{item.inquiryStatusName}}</div>
              </div>
              <div style="margin-bottom:16px" class="inquiry-style">
                <span>{{item.inquiryTheme}}</span>
              </div>
              <div class="justify-align-style inquiry-style order-num-line">
                <div><span>订单编号：</span>{{item.orderNo}}</div>
                <div>
                  <el-button type="primary" size="small" @click="handleOrderDetail(item)">订单详情</el-button>
                  <el-button v-if="item.inquiryStatus != 5 && item.inquiryStatus != 7" type="primary" size="small"
                    @click="startDialog(item,true)">历史对话</el-button>
                </div>
              </div>
            </div>
            <div v-if="!doneList.length" class="no-data-wrapper">
              <img src="../../../../assets/images/empty.png">
              <div>暂无数据</div>
            </div>
          </div>
          <div v-if="!doneList && !doingList" class="no-data-wrapper">
            <img src="../../../../assets/images/empty.png">
            <div>暂无数据</div>
          </div>
        </el-scrollbar>
        <!-- 新增会话 -->
        <div class="new-interrogation-dialog" v-show="isEdit">
          <h1 class="title">新增专项对话</h1>
          <el-radio-group v-model="temp.mode" size="mini" class="interrogation-type" @change="changeMode">
            <el-radio-button label="1">个人问诊</el-radio-button>
            <el-radio-button label="2">团队问诊</el-radio-button>
            <el-radio-button label="3" v-if="showFreeClinic">义诊</el-radio-button>
          </el-radio-group>
          <!-- <el-scrollbar style="height: calc(100% - 156px)"> -->
          <el-form ref="inqueryFormRef" label-width="100px" :model="temp" :rules="rules" size="small">
            <div v-show="temp.mode == 1 || temp.mode == 3">
              <el-form-item label="线下机构：" prop="hospitalId">
                <el-select class="inputBox" v-model="temp.hospitalId" filterable placeholder="请选择线下机构"
                  @change="changeHospital">
                  <el-option :label="item.name" :value="item.id" v-for="(item, index) in hospitalList" :key="index">
                  </el-option>
                </el-select>
                <!-- <span v-else>{{this.$store.state.serviceItem.hospitalName}}</span> -->
              </el-form-item>
              <el-form-item label="问诊医生：" prop="doctorId">
                <el-select class="inputBox" v-model="temp.doctorItem" value-key="id" placeholder="请选择问诊医生" filterable
                  @change="changeDoctors">
                  <el-option :label="item.name" :value="item" v-for="item in inquiryDoctorsData" :key="item.id">
                  </el-option>
                </el-select>
                <p v-show="temp.doctorId && (!temp.doctorItem.inquiryConfig || !temp.doctorItem.openInquiry || temp.doctorItem.inquiryConfig.disabled)"
                  class="err-tooltip">当前医生暂未开通图文问诊，请前往医护信息进行配置</p>
              </el-form-item>
              <el-form-item label="问诊类型：" prop="serviceCode">
                <el-select class="inputBox" v-model="temp.serviceCode" placeholder="请选择问诊类型">
                  <el-option :label="item.serviceName" :value="item.serviceCode" v-for="item in addnewdata"
                    :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="temp.payMode == 1" label="抵扣权益：" prop="rightId">
                <el-select v-model="temp.rightId" placeholder="请选择">
                  <el-option v-for="(item,index) in rightsList" v-if="item.serviceType == 1" :key="index" :label="item.label" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="对话主题：" prop="inquiryTheme">
                <el-input type="text" class="inputBox" v-model="temp.inquiryTheme" maxlength="20" placeholder="请输入对话主题"
                  clearable>
                </el-input>
              </el-form-item>
              <!-- <el-form-item label="服务时长：" prop="serviceTime">
                <el-input type="number" class="inputBox serviceTime" v-model="temp.serviceTime"
                  placeholder="请输入服务时长" clearable>
                  <template slot="append">
                    <el-select v-model="temp.timeUnit">
                      <el-option label="分钟" :value="1"></el-option>
                      <el-option label="小时" :value="2"></el-option>
                    </el-select>
                    {{ temp.timeUnit == 1 ? '分钟' : '小时' }}
                  </template>
                </el-input>
              </el-form-item> -->

              <el-form-item label="服务时长：" prop="serviceTime">
                <el-input v-model="temp.serviceTime" size="medium" clearable placeholder="请输入服务时长">
                  <el-select v-model="temp.timeUnit" slot="append" placeholder="请选择" style="width:unset">
                    <el-option label="分钟" :value="1"></el-option>
                    <el-option label="小时" :value="2"></el-option>
                  </el-select>
                </el-input>
              </el-form-item>
              <el-form-item v-show="temp.payMode == 1" label="服务价格：">
                <span>权益抵扣</span>
              </el-form-item>
              <el-form-item v-show="temp.payMode == 2 || temp.payMode == 3" label="服务价格：">
                <span>{{temp.servicePrice / 100}}元</span>
              </el-form-item>
            </div>
            <div v-show="temp.mode == 2">
              <el-form-item label="线下机构：" prop="hospitalId">
                <el-select class="inputBox" v-model="temp.hospitalId" filterable placeholder="请选择线下机构"
                  @change="changeHospital">
                  <el-option :label="item.name" :value="item.id" v-for="(item, index) in hospitalList" :key="index">
                  </el-option>
                </el-select>
                <!-- <span v-else>{{this.$store.state.serviceItem.hospitalName}}</span> -->
              </el-form-item>
              <el-form-item v-if="temp.mode == 2" label="问诊团队：" prop="doctorTeamId">
                <el-select class="inputBox" v-model="temp.doctorItem" value-key="id" placeholder="请选择问诊团队" filterable
                  @change="selectDocTeam">
                  <el-option :label="item.name" :value="item" v-for="(item, index) in doctorTeamsList" :key="index">
                  </el-option>
                </el-select>
                <p v-show="temp.doctorTeamId && (!temp.doctorItem.inquiryConfig || !temp.doctorItem.openInquiry || temp.doctorItem.inquiryConfig.disabled)"
                  class="err-tooltip">当前团队暂未开通图文问诊，请前往医护信息进行配置</p>
              </el-form-item>
              <el-form-item label="主诊医生：" prop="doctorId"> 
                <el-select class="inputBox" v-model="temp.doctorId" placeholder="请选择主诊医生" filterable>
                  <el-option :label="item.name" :value="item.id" v-for="item in inquiryDoctorsData" :key="item.id">
                  </el-option>
                </el-select>

                <el-tooltip class="item" effect="dark" content="仅此医生可填写患者病历并开具处方" placement="top-end">
                  <i class="el-icon-warning-outline"
                    style="position: fixed; transform: translateX(5px);font-size: 20px;line-height: 32px;font-weight: bolder;"></i>
                </el-tooltip>
              </el-form-item>
              <el-form-item label="问诊类型：" prop="serviceCode">
                <el-select class="inputBox" v-model="temp.serviceCode" placeholder="请选择问诊类型">
                  <el-option :label="item.serviceName" :value="item.serviceCode" v-for="(item, index) in addnewdata"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="temp.payMode == 1" label="抵扣权益：" prop="rightId"> 
                <el-select v-model="temp.rightId" placeholder="请选择">
                  <el-option v-for="(item,index) in rightsList" v-if="item.serviceType == 1" :key="index" :label="item.label" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="对话主题：" prop="inquiryTheme">
                <el-input type="text" class="inputBox" v-model="temp.inquiryTheme" maxlength="20" placeholder="请输入对话主题"
                  clearable>
                </el-input>
              </el-form-item> 
              <el-form-item label="服务时长：" prop="serviceTime">
                <el-input v-model="temp.serviceTime" size="medium" clearable placeholder="请输入服务时长">
                  <el-select v-model="temp.timeUnit" slot="append" placeholder="请选择" style="width:unset">
                    <el-option label="分钟" :value="1"></el-option>
                    <el-option label="小时" :value="2"></el-option>
                  </el-select>
                </el-input>
              </el-form-item>

              <el-form-item v-show="temp.payMode == 1" label="服务价格：">
                <span>权益抵扣</span>
              </el-form-item>
              <el-form-item v-show="temp.payMode == 2" label="服务价格：">
                <span>{{temp.servicePrice / 100}}元</span>
              </el-form-item>
            </div>
          </el-form>
          <div class="btnBox">
            <div class="resetting" @click="createRoomBtn">取 消</div>
            <div class="save" @click="addallwhole" v-loading="btnLoading" element-loading-spinner="el-icon-loading">开启，发送给患者</div>
            <div class="resetting reset" @click="changeMode">重 置</div>
          </div>
          <!-- </el-scrollbar> -->
        </div>

        <!-- 弹窗信息 -->
        <el-drawer :visible.sync="drawerFlag" size="46%" style="overflow: auto;height:100%" :with-header="false">
          <!-- 问诊订单 -->
          <div class="popup-view">
            <el-form label-position="left" label-width="120px">
              <el-form-item label="订单编号：" class="el-formno-bottom">
                <el-col :span="11">
                  <span>{{ orderDetails.orderInfoVO.orderNo }}</span>
                </el-col>
              </el-form-item>
              <el-form-item label="订单状态：" class="el-formno-bottom">
                <el-col :span="11">
                  <span>{{ orderDetails.orderPayVO.paymentState | payStatus }}</span>
                </el-col>
                <el-col :span="13" class="flex-view">
                  <span class="labelRight">问诊状态：</span>
                  <span>{{ orderDetails.orderInquiryDetailVO.inquiryStatusName }}</span>
                </el-col>
              </el-form-item>
              <el-form-item label="病人：" class="el-formno-bottom">
                <el-col :span="11">
                  <span>{{ orderDetails.orderInfoVO.patientName }}</span>
                </el-col>
                <el-col :span="13" class="flex-view">
                  <span class="labelRight">问诊类型：</span>
                  <span>{{  orderDetails.orderInquiryDetailVO.returnVisitType==1?'图文问诊':'' }}</span>
                </el-col>
              </el-form-item>
              <el-form-item label="问诊团队：" class="el-formno-bottom"
                v-if="orderDetails.orderInquiryDetailVO.serviceProvider=='2'">
                <el-col :span="11">
                  <span>{{ orderDetails.orderInfoVO.doctorTeamName }}</span>
                </el-col>
                <el-col :span="13" class="flex-view">
                  <span class="labelRight">主诊医生：</span>
                  <span>{{ orderDetails.orderInfoVO.doctorName }}</span>
                </el-col>
              </el-form-item>
              <el-form-item label="问诊医生：" class="el-formno-bottom"
                v-if="orderDetails.orderInquiryDetailVO.serviceProvider=='1'">
                <el-col :span="11">
                  <span>{{ orderDetails.orderInfoVO.doctorName }}</span>
                </el-col>
                <el-col :span="13" class="flex-view">
                  <span class="labelRight">职称：</span>
                  <span>{{ orderDetails.orderInfoVO.jobTitle }}</span>
                </el-col>
              </el-form-item>
              <el-form-item label="抵扣权益：" class="el-formno-bottom">
                <el-col :span="11" v-if="orderDetails.orderPayVO.paymentMethid=='4'">
                  <span>{{  orderDetails.orderInquiryDetailVO.serviceName }}</span>
                </el-col>
                <el-col :span="11" v-else>
                  <span>--</span>
                </el-col>
                <el-col :span="13" class="flex-view">
                  <span class="labelRight">创建时间：</span>
                  <span>{{ orderDetails.orderInquiryDetailVO.createTime }}</span>
                </el-col>
                <!-- <el-col :span="13" class="flex-view">
                <span class="labelRight">线下机构：</span>
                <span>{{ orderDetails.orderInfoVO.hospitalName }}</span>
              </el-col> -->
              </el-form-item>
              <!-- <el-form-item label="创建时间：" class="el-formno-bottom">
              <el-col :span="11">
                <span>{{ orderDetails.orderInquiryDetailVO.createTime }}</span>
              </el-col> -->
              <!-- <el-col :span="13" class="flex-view">
                <span class="labelRight">互医机构：</span>
                <span>{{ orderDetails.orderInfoVO.platformName  }}</span>
              </el-col> -->
              <!-- </el-form-item> -->
              <!-- <el-form-item v-if="$store.state.userPlatForm === 'organization'" label="互医机构" class="el-formno-bottom">
              <el-col :span="11">
                <span>{{ orderDetails.doctorVO.platformName }}</span>
              </el-col>
            </el-form-item>
            <el-form-item v-if="$store.state.userPlatForm === 'platForm'" label="线下机构" class="el-formno-bottom">
              <el-col :span="11">
                <span>{{ orderDetails.orderInfoVO.hospitalName }}</span>
              </el-col>
              <el-col :span="11" class="flex-view">
                <div>互医机构</div>
                <span>{{ orderDetails.orderInfoVO.platformName }}</span>
              </el-col>
            </el-form-item> -->
              <!-- <el-form-item label="归属平台" class="el-formno-bottom">
              <el-col :span="11">
                <span>{{ orderDetails.doctorVO.platformName }}</span>
              </el-col>
              <el-col :span="11" class="flex-view">
                <div>服务名称</div>
                <span>{{ orderDetails.orderInquiryDetailVO.serviceName }}</span>
              </el-col>
            </el-form-item> -->
              <!-- <el-form-item label="服务名称" class="el-formno-bottom">
              <el-col :span="11">
                <span>{{ orderDetails.orderInquiryDetailVO.serviceName }}</span>
              </el-col>
            </el-form-item> -->
              <el-form-item label="服务单价：" class="el-formno-bottom">
                <el-col :span="11" class="flex-view">
                  <span>{{ orderDetails.orderInfoVO.amountOriginal }}</span>
                </el-col>
                 <el-col :span="13" class="flex-view">
                  <span class="labelRight">服务类型：</span>
                  <span>{{orderDetails.orderInquiryDetailVO.inquiryType==1?'权益问诊':orderDetails.orderInquiryDetailVO.inquiryType== 2 ?'付费问诊':'义诊'}}</span>
                </el-col>
              </el-form-item>
              <el-form-item label="应付金额：" class="el-formno-bottom">
                <el-col :span="11">
                  <span>{{ orderDetails.orderInfoVO.amountPayable }}</span>
                </el-col>
                <el-col :span="13" class="flex-view">
                  <span class="labelRight">优惠金额：</span>
                  <span>{{ orderDetails.orderInfoVO.amountPayable - orderDetails.orderInfoVO.amountOriginal == 0 ? '-' : orderDetails.orderInfoVO.amountPayable - orderDetails.orderInfoVO.amountOriginal }}</span>
                </el-col>
              </el-form-item>
              <el-form-item label="实付金额：" class="el-formno-bottom">
                <el-col :span="11">
                  <span>{{ orderDetails.orderPayVO.payAmount }}</span>
                </el-col>
                <el-col :span="13" class="flex-view">
                  <span class="labelRight">商户订单号：</span>
                  <span>{{ orderDetails.orderPayVO.transactionNo?orderDetails.orderPayVO.transactionNo:'--' }}</span>
                </el-col>
              </el-form-item>
              <!-- <el-form-item label="创建时间" class="el-formno-bottom">
              <el-col :span="11">
                <span>{{ orderDetails.orderInquiryDetailVO.createTime }}</span>
              </el-col>
              <el-col :span="11" class="flex-view">
                <div>订单状态</div>
                <span>{{ orderDetails.orderPayVO.paymentState | payStatus }}</span>
              </el-col>
            </el-form-item> -->
              <el-form-item label="支付方式：" class="el-formno-bottom">
                <el-col :span="11">
                  <span>{{ orderDetails.orderPayVO.paymentMethid |filterPay }}</span>
                </el-col>
                <el-col :span="13" class="flex-view">
                  <span class="labelRight">支付时间：</span>
                  <span>{{ orderDetails.orderPayVO.payTime }}</span>
                </el-col>
              </el-form-item>
              <el-form-item label="服务时长：" class="el-formno-bottom">
                <el-col :span="11">
                  <span>{{ orderDetails.orderInquiryDetailVO.serviceTime }}</span>
                </el-col>
              </el-form-item>
              <el-form-item label="服务开始时间：" class="el-formno-bottom">
                <el-col :span="11">
                  <span>{{ orderDetails.orderInquiryDetailVO.startTime }}</span>
                </el-col>
                <el-col :span="13" class="flex-view">
                  <span class="labelRight">服务结束时间：</span>
                  <span>{{ orderDetails.orderInquiryDetailVO.endTime }}</span>
                </el-col>
              </el-form-item>
              <el-form-item label="退款人：" class="el-formno-bottom">
                <el-col :span="11">
                  <span>{{ orderDetails.orderPayVO.createUserName?orderDetails.orderPayVO.createUserName:'--' }}</span>
                </el-col>
                <el-col :span="13" class="flex-view">
                  <span class="labelRight">退款时间：</span>
                  <span>{{ orderDetails.orderPayVO.refundTime?orderDetails.orderPayVO.refundTime:'--' }}</span>
                </el-col>
              </el-form-item>
              <el-form-item label="退款金额：" class="el-formno-bottom">
                <el-col :span="11">
                  <span>{{ orderDetails.orderPayVO.refundMoney?orderDetails.orderPayVO.refundMoney:"--" }}</span>
                </el-col>
                <el-col :span="13" class="flex-view">
                  <span class="labelRight">退款说明：</span>
                  <span>{{ orderDetails.orderPayVO.refundText?orderDetails.orderPayVO.refundText:'--' }}</span>
                </el-col>
              </el-form-item>
            </el-form>
          </div>

        </el-drawer>

      </div>

      <!-- 未购买服务 -->
      <!-- <div class="empty" v-if="statusIMInfo == 1">
      <div class="flex-empty">
        <img src="@/assets/images/service-nobuy.png" alt="no-data">
        <div class="banner-text">患者暂未购买服务</div>
      </div>
    </div> -->
    </div>
  </div>
</template>

<script>
import {
  api_getInquiryList,
  api_getMembersByWholeId,
  api_createWholeInquiry,
  api_getintoInquiryRoom,
  api_getgetServiceByType,
  api_get_case_message,
  getMembersByGroupCode,
  getPrescriberListByTeamId
} from "@/api/apiIM.js";
import {
  getPatientRights,
  getInquiryInfoByPatientId,
  createInquiry,
  getInquiryDoctors,
  getAttendingDoctorByTeamId,
  getInquiryDoctorTeams,
  caseMgrCancelled,
  getOrderDetails,
  getListByPlatformId,
  detailByRefId
} from "@/api/apiIM.js";
// import { plateFormAll } from "@/api/acc.js";
import { apiWholeCourseHandler } from "@/views/treatment/api";
export default {
  name: "CreateRoom",
  props: {
    wholeCourseId: {
      type: String,
      default: ""
    },
    statusIMInfo: {
      type: Number,
      default: 0
    },
    IMInfo: {
      type: Object,
      default: () => {}
    }
  },
  filters: {
    filterServiceCode(key) {
      switch (key * 1) {
        case 1:
          return "在线问诊";
        case 2:
          return "在线续方";
        case 3:
          return "在线随访";
        case 4:
          return "在线复诊";
        default:
          return "未知";
      }
    },
    payStatus(key) {
      switch (key * 1) {
        case 1:
          return "待支付";
        case 2:
          return "已支付";
        case 3:
          return "已取消";
        case 4:
          return "退款完成";
        case 7:
          return "已完成";
        case 8:
          return "待退款";
        default:
          return "未知";
      }
    },
    inquiryStatus(key) {
      switch (key * 1) {
        case 0:
          return "未支付";
        case 1:
          return "未开始";
        case 2:
          return "待接诊";
        case 3:
          return "进行中";
        case 4:
          return "已完成";
        case 5:
          return "已退诊";
        case 6:
          return "自动结束";
        case 7:
          return "医生未接诊结束";
        case 8:
          return "个案结束问诊";
        default:
          return "未知";
      }
    }
  },
  data() {
    return {
      showFreeClinic:true,
      hospitalList: [],
      orderDetails: {
        orderDrugDetailVO: {},
        doctorVO: {},
        orderInfoVO: {},
        orderInquiryDetailVO: {},
        orderPayVO: {},
        wholeCourseVO: {},
        elecPrescriptionVO: {}
      },
      drawerFlag: false,
      // patientServiceObj: {},
      temp: {
        belong:'',
        hospitalId: "",
        // wholeCourseId: "",
        serviceCode: "",
        inquiryTheme: "",
        serviceTime: "",
        serviceTimeType: 1,
        timeUnit: 1,
        // users: [],
        doctorId: "",
        doctorTeam: "",
        rightId: "",
        mode: 1, // 问诊类型，1个人类型 2团队类型 3义诊
        doctorItem: {
          inquiryConfig: {}
        },
        servicePrice: 0, 
        doctorTeamId: "",
        // doctorTeamItem: {},
        payMode: 1 //1: 使用权益 2: 货币 3:免费(义诊)	
      },
      rules: {
        hospitalId: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        // serviceTime: [],
        doctorId: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        doctorTeamId: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        serviceTime: [
          {
            pattern: /^[1-9]+[0-9]*$/,
            message: "请输入正整数",
            trigger: ["change", "blur"]
          },
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        serviceCode: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        rightId: [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ]
      },
      addnewdata: [],
      // docList: [], // 处方医生列表
      // msgtabledata1: [],
      // user: [],
      // dataFormLoading: false,
      // lxs 避免多个开关影响
      isEdit: false, 
      // messageMiniRoomList: [], //当前人员专项对话房间列表

      rightsData: [],
      rightsList: [],
      ruleTypeArr: ["不限制", "次", "次/天", "次/周", "次/月", "次/年"],
      doingList: [],
      doneList: [], 
      inquiryDoctorsData: [],
      doctorTeamsList: [], 
      // inquiryDoctorsData: [],
      totalRightsCount: 0,
      btnLoading: false,// 开启，发送给患者按钮防止重复多次点击
    };
  },
  watch: {
    "$store.state.serviceItem.value": {
      async handler(newVal, oldVal) {
        // 重置数据
        this.hospitalList = [];
        this.isEdit = false;
        this.doingList = [];
        this.doneList = [];
        this.totalRightsCount = 0;
        await this.getHospitalList();
        this.getPatientRightsData();
        this.getInquiryInfoData();
      },
      deep: true
    }
  },
  async created() {
    // this.statusIMInfo !== 1 && this.getDocList();
    this.getBaseData();
    // this.gitParentRoomList();
    // await this.getDefaultPatientService()
    if (JSON.stringify(this.$store.state.serviceItem) !== "{}") {
      await this.getHospitalList();
      this.getPatientRightsData();
    }
    this.getInquiryInfoData();
  },
  methods: {
    // 获取线下机构
    async getHospitalList() {
      // 服务咨询 type:服务类型 1：服务链 2疗管链
      if (
        this.$store.state.serviceItem.consult ||
        this.$store.state.serviceItem.type == 2 || (this.temp.mode == 3 && this.$store.state.userPlatForm=='platForm')
      ) {
        let res = await getListByPlatformId(
          this.$store.state.serviceItem.platformId
        );
        if (res.code === 0) {
          // 线下机构
          this.hospitalList = res.data;
        }
        // 接口获取数据（该机构下的全部医生 和 团队）
      } else {
        // 其他服务（全病程的线下机构）
        this.hospitalList = [
          {
            id: this.$store.state.serviceItem.hospitalId,
            name: this.$store.state.serviceItem.hospitalName
          }
        ];
      }
    },
    changeHospital(val) {
      this.temp.doctorItem = {
        inquiryConfig: {}
      };
      this.inquiryDoctorsData = [];
      this.doctorTeamsList = [];
      this.temp.doctorId = "";
      this.temp.doctorTeamId = "";
      this.temp.serviceCode = "";
      this.temp.rightId = "";
      this.temp.inquiryTheme = "";
      this.temp.serviceTime = "";
      this.temp.timeUnit = 1;
      this.temp.servicePrice = 0;
      // 个人
      if (this.temp.mode == 1 || this.temp.mode == 3) {
        this.getInquiryDoctorsData(val);
      }
      // 团队
      if (this.temp.mode == 2) {
        this.getInquiryDoctorTeamsData(val);
      }
    },

    // 切换问诊医生/主诊医生
    changeDoctors(val) {
      this.temp.serviceCode = "";
      this.temp.rightId = "";
      this.temp.inquiryTheme = "";
      this.temp.serviceTime = "";
      this.temp.timeUnit = val.inquiryConfig ? 2 : 1;
      this.temp.servicePrice = 0;

      this.temp.doctorId = val.id;
      //义诊服务价格为0
      if (this.temp.payMode == 2 && this.temp.mode != 3) {  
           this.temp.servicePrice = val.inquiryConfig
          ? val.inquiryConfig.consultFee
          : 0; 
      }
      this.temp.serviceTime = val.inquiryConfig
        ? val.inquiryConfig.serviceTime
        : "";
    },

    // 选择问诊团队获取主诊医生
    async selectDocTeam(val) {
      this.temp.doctorId = "";
      this.inquiryDoctorsData = [];
      if (this.temp.payMode == 2) {
        this.temp.servicePrice = val.inquiryConfig
          ? val.inquiryConfig.consultFee
          : 0;
      }
      this.temp.serviceTime = val.inquiryConfig
        ? val.inquiryConfig.serviceTime
        : "";
      this.temp.timeUnit = val.inquiryConfig ? 2 : 1;
      this.temp.doctorTeamId = val.id;
      let res = await getAttendingDoctorByTeamId({
        teamId: val.id,
        mode:this.temp.mode
      });
      if (res.code === 0) {
        this.inquiryDoctorsData = res.data;
      }
    }, 
    async handleOrderDetail(item) {
      let res = await getOrderDetails(item.orderId);
      if (res.code == 0) {
        this.orderDetails = res.data;
        this.drawerFlag = true;
      }
    },
    changeMode(val) { 
      this.temp.doctorItem = {
        inquiryConfig: {}
      };
      // this.temp.mode = val
      this.inquiryDoctorsData = [];
      this.doctorTeamsList = [];
      this.temp.servicePrice = 0;
      this.$refs.inqueryFormRef.resetFields();
      this.temp.doctorTeamId = "";
      this.temp.doctorId = "";
      this.temp.serviceTime = "";
      this.temp.timeUnit = 1; 
      if(this.showFreeClinic){
        //货币
        if(val == 3){ //义诊
          this.temp.payMode = 3 
        }else{
          this.temp.payMode = 2
        }
      }else{
        //使用权益
        this.temp.payMode = 1
      }
       this.getHospitalList() 
    },

    // 获取问诊医生
    async getInquiryDoctorsData(hospitalId) {
      this.inquiryDoctorsData = [];
      if (
        (this.temp.payMode == 2|| this.temp.payMode == 3) &&
        (this.$store.state.serviceItem.consult ||
          this.$store.state.serviceItem.type == 2)|| this.temp.mode == 3
      ) {
        let res = await getInquiryDoctors({
          hospitalId: hospitalId,
          mode:this.temp.mode
        });
        if (res.code === 0) {
          this.inquiryDoctorsData = res.data;
        }
      } else {
        let res = await getAttendingDoctorByTeamId({
          teamId: this.$store.state.serviceItem.doctorTeamId,
          mode:this.temp.mode
        });
        if (res.code === 0) {
          this.inquiryDoctorsData = res.data;
        }
      }
    },
    // 获取问诊团队
    async getInquiryDoctorTeamsData(hospitalId) {
      this.doctorTeamsList = [];
      if (
        this.$store.state.serviceItem.consult ||
        this.$store.state.serviceItem.type == 2
      ) {
        let res = await getInquiryDoctorTeams({
          // id: this.$store.state.serviceItem.doctorTeamId,
          hospitalId: hospitalId
        });
        if (res.code === 0) {
          this.doctorTeamsList = res.data;
        }
      } else { 
        let res = await getInquiryDoctorTeams({
          id: this.$store.state.serviceItem.doctorTeamId 
        });
        if (res.code === 0) {
          this.doctorTeamsList = res.data;
        }
      }
    },

    // 取消订单
    async handleCaseMgrCancelled(data) {
      let noticeMsg;
      if (data.payMode == 1) {
        noticeMsg = "取消订单并归还权益次数";
      } else {
        noticeMsg = "患者已支付，是否确认取消问诊订单";
      }
      this.$confirm(noticeMsg, {
        distinguishCancelAndClose: true,
        center: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm"
      }).then(async () => {
        let res = await caseMgrCancelled({
          inquiryId: data.id
        });
        if (res.code === 0) {
          this.$message.success("订单已取消");
          this.getPatientRightsData();
          this.getInquiryInfoData();
        }
      });
    },

    async getPatientRightsData() {
      this.rightsData = [];
      this.rightsList = [];
      this.totalRightsCount = 0;
      if (!this.$store.state.serviceItem.patientSchemeId) return;
      let res = await getPatientRights(
        this.$store.state.serviceItem.patientSchemeId
      );
      if (res.code === 0) {
        this.rightsData = res.data;
        this.rightsList = res.data.filter(v => v.count != 0);
        this.rightsList.forEach(item => {
          if (item.count == null) {
            item.label = `${item.name}-不限制`;
          } else {
            item.label = `${item.name}-余${item.count}`;
          }
        });
        // 统计剩余权益次数
        // this.rightsData.map(v => v.count)
        this.totalRightsCount = this.rightsData.reduce(
          (pre, cur) => pre + (cur.count != null ? cur.count : 1),
          0
        );
      }
    },
    async getInquiryInfoData() {
      let res = await getInquiryInfoByPatientId({
        patientId: this.IMInfo.patientId
      });
      if (res.code === 0) {
        this.doingList = res.data.doingList;
        this.doneList = res.data.doneList;
      }
    },

    //开始对话按钮
    async startDialog(item, isHistory) {
      // if(item)
      //根据当前对象获取房间号问诊信息
      if (item.id) {
        let res = await api_getintoInquiryRoom({
          inquiryId: item.id
        });
        //拿到二级房间号
        let groupCode = res.data.groupCode;
        //问诊类型
        let serviceCode = res.data.serviceCode;
        //结束需要的id
        let roomcodeId = res.data.id;

        // 问诊状态
        let inquiryStatus = item.inquiryStatus;
        this.$parent.enterMessage(
          groupCode,
          serviceCode,
          roomcodeId,
          inquiryStatus,
          isHistory
        );
        this.$socket.emit("setGroupCode", groupCode, data => {});
      } 
    },
    //新增会话按钮
    addNewDialogue() {
      this.isEdit = true;
      this.showFreeClinic = true
      // this.useRights = false
      this.temp.payMode = 2; 
      this.changeMode();
      // this.temp.hospitalId = ''
      this.temp.mode = 1;
    },
    handleUseRights() {
      this.isEdit = true;
      this.showFreeClinic = false 
      this.temp.payMode = 1; 
      this.changeMode();  
      this.temp.mode = 1;
    }, 
    async getBaseData() {
      let res = await api_getgetServiceByType({
        serviceType: 1
      });
      this.addnewdata = res.data; 
    }, 
    async addallwhole() {
      let valRes;
      this.$refs.inqueryFormRef.validate(val => {
        valRes = val;
      });
      if (!valRes) {
        return;
      }
      // 限制服务时长
      // 分钟
      if (this.temp.timeUnit == 1) {
        if (
          this.temp.serviceTime >
          this.temp.doctorItem.inquiryConfig.serviceTime * 60
        ) {
          this.$message.error(
            "服务时长不可大于医生/医生团队在问诊配置中配置的时长"
          );
          return;
        }
      }
      if (this.temp.timeUnit == 2) {
        if (
          this.temp.serviceTime > this.temp.doctorItem.inquiryConfig.serviceTime
        ) {
          this.$message.error(
            "服务时长不可大于医生/医生团队在问诊配置中配置的时长"
          );
          return;
        }
      }
      if (
        !this.temp.doctorItem.inquiryConfig ||
        !this.temp.doctorItem.openInquiry ||
        this.temp.doctorItem.inquiryConfig.disabled
      ) {
        // this.$message.error('暂未开通图文问诊，请前往医护信息进行配置')
        return;
      } 
      this.btnLoading = true;
      if(this.temp.mode == 2){
        this.temp.belong = 2
      }else{
        this.temp.belong = 1
      }
      if(this.temp.mode == 3){ //义诊
        this.temp.payMode = 3
      } 
      let res = await createInquiry({
        ...this.temp, 
        wholeCourseId: this.$store.state.serviceItem.wholeCourseId,
        wholeCourseGroupCode:this.$store.state.serviceItem.imId.slice(5)
      }).catch(err=>{});  
      if (res && res.code === 0) {
        this.$message.success("创建成功");
        this.btnLoading = false;
        this.isEdit = false; 
        this.getPatientRightsData();
        this.getInquiryInfoData();
      } else {
        this.btnLoading = false;
      } 
    }, 
    createRoomBtn() {
      this.isEdit = false;
    }
  }
};
</script>

<style scoped lang="less">
@import "./indexNew.less";
// @import "./index.less";
.free-clinic {
  display: inline-block;
  width: 50px;
  height: 22px;
  border-radius: 11px;
  border: 1px solid #ff722d;
  color: #ff722d;
  font-size: 12px;
  margin-right: 10px;
  text-align: center;
  line-height: 20px;
  img {
    width: 14px;
    height: 14px;
    vertical-align: middle;
  }
}
.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  .banner-text {
    margin: 20px 0 60px 0;
    text-align: center;
  }
}
.add-interrogation {
  padding: 20px 24px;
  background: #f8f8f8;
  border-radius: 6px;

  width: 100%;
  color: #1a7bfc;
  line-height: 22px;
  text-align: right; 
  font-size: 16px;
  font-weight: 600; 
  span {
    cursor: pointer;
  }
}
.mini-room-box {
  // height: calc(100vh - 275px);
  height: 100%;
  padding: 20px 20px 20px 0;
  .no-idCard {
    font-size: 14px;
    color: #666666;
    text-align: center;
    margin-top: 220px;
  } 
  .no-data-wrapper {
    margin-top: 120px;
    text-align: center;
    div {
      font-size: 14px;
      color: #666666;
      margin-right: 20px;
    }
  }
  .rest-rights {
    width: 100%; 
    padding: 20px 24px;
    background: #f8f8f8;
    border-radius: 6px;
    .rest-left {
      // width: 80px;
      // height: 22px;
      font-size: 16px; 
      font-weight: 600;
      color: #333333;
      line-height: 22px;
    }
    .rest-right {
      // width: 64px;
      // height: 22px;
      font-size: 16px; 
      font-weight: 600;
      color: #1a7bfc;
      line-height: 22px;
      span {
        cursor: pointer;
      }
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      // margin-top: 16px;
      li {
        margin-right: 16px;
        font-size: 14px;
        color: #333333;
        line-height: 22px;
      }
    }
    .rights-blue {
      display: inline-block;
      margin-left: 8px;
      color: #1a7bfc;
    }
    .no-rights {
      height: 22px;
      font-size: 14px;
      color: #333333;
      line-height: 22px;
    }
  }
  .justify-align-style {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  } 
  h3 {
    margin-top: 24px;
    margin-bottom: 8px;
    height: 25px;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    line-height: 25px;
  }
  .inquiry-style {
    font-size: 14px;
    color: #333333;
    line-height: 22px;
    div:nth-child(1) {
      span {
        color: #666666;
      }
    }
    div:nth-child(2) {
      > span {
        color: #666666;
      }
    }
  }
  .justify-align-style:last-child {
    margin-bottom: 0;
  }
  .cancel-order {
    color: #1a7bfc;
    border: 1px solid #1a7bfc;
  }
  .order-num-line {
    line-height: 32px;
  }
  .justify-team-info {
    > span {
      margin-right: 24px;
      color: #333333;
    }
  }
  .money-num {
    color: #f14352 !important;
  }
  .pay-status {
    width: 54px;
    height: 22px;
    background: #1a7bfc;
    border-radius: 11px;
    color: #ffffff;
    text-align: center;
    line-height: 22px;
  }
  .doing-inquiry {
    margin-bottom: 20px;
  }
}
.err-tooltip {
  font-size: 10px;
  font-weight: 400;
  color: #f14352;
}

.qrcode-view {
  div {
    width: 48px;
    height: 12px;
    padding: 9px 15px;
    margin-right: 20px;
  }
}
.demo-form-inline {
  /deep/ .el-date-range-picker {
    width: 515px;
  }
}
.el-tabs-view {
  background-color: #ffffff;
  border-radius: 10px;
}
.popup-view {
  padding: 0 20px;
  height: 100%;
  overflow: auto;
  .el-from1 {
    .float {
      float: left;
    }
  }
  .img-view {
    width: 100px;
    height: 100px;
    object-fit: cover;
  }
  .flex-view {
    display: flex;
    align-items: center;
    div {
      font-size: 14px;
      color: #606266;
      margin-left: 12px;
      width: 100px !important;
    }
    .labelRight {
      width: 100px !important;
      color: #606266;
      font-size: 14px;
    }
  }
  .el-formno-bottom,
  .el-h1 {
    margin-bottom: 0 !important;
    border-bottom: 1px solid #ebeef5;
  }
}
/deep/.el-drawer__body {
  overflow-y: scroll;
  height: 100%;
}
/deep/ .el-col-11 {
  min-height: 1px;
}

/deep/.el-loading-spinner {
  margin-top: -17px;
}
</style>
<style>
.mini-room-box .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>